import React, { useEffect } from 'react';
import { HeaderGlobal, Breadcrumb } from 'src/components';
import DetailboxGrafis from './DetailboxGrafis';
import {
    setDataInfoGraphic
} from 'src/config/redux/action/';
import { useSelector, useDispatch } from 'react-redux';
import { Helmet } from "react-helmet";

const DetailInfoGrafisComponent = ({ match, crumbs }) => {
    var PARAMIdDetail = match.params.iddetail;

    const { dataInfoGraphic } = useSelector(state => state.infoGraphicReducer)
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(setDataInfoGraphic(PARAMIdDetail))
        window.scrollTo({ top: 0, behavior: "smooth" })
    }, [dispatch])


    return (
        <>
            {
                dataInfoGraphic &&
                <Helmet>
                    <meta charSet='utf-8' />
                    <title>{`${dataInfoGraphic.Title} | Portal Satu Data Kabupaten Sigi`}</title>
                    <meta name='description' content={`Info Grafis - ${dataInfoGraphic.Title} | Portal Satu Data Kabupaten Sigi`} />
                </Helmet>
            }
            <div className="site-main">
                <HeaderGlobal />
                <section className="ttm-row aboutus-section clearfix">
                    <div className="container-xl mt-4 res-767-mt-0">

                        {/* BREADCUMB */}
                        <Breadcrumb crumbs={crumbs} />
                        {/* BREADCUMB */}

                        {
                            dataInfoGraphic ?
                                <div className="row">
                                    <div className="col-lg-6 col-xl-7">
                                        <div className="featured-imagebox featured-imagebox-blog style2 mb-10">
                                            <div className="ttm_single_image-wrapper mb-35">
                                                <img className="img-fluid" src={dataInfoGraphic.UrlThumbnail} title={dataInfoGraphic.Slug} alt={dataInfoGraphic.Slug} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-xl-5">
                                        <DetailboxGrafis {...dataInfoGraphic} />
                                    </div>
                                </div>
                                : null
                        }


                    </div>
                </section>

            </div>
        </>
    )
}

export default DetailInfoGrafisComponent;